// GENERATED from ez-tree preset "Oak Small" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const OakSmall_KIND_ID = "ezTree_OakSmall";

export const OakSmallKind = new SceneryKindDef({
	id: "ezTree_OakSmall",
	name: "Oak Small",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchAngle1": 54,
		"branchAngle2": 58,
		"branchAngle3": 32,
		"branchChildren0": 4,
		"branchChildren1": 2,
		"branchChildren2": 3,
		"branchGnarliness0": 0.07,
		"branchGnarliness1": -0.08,
		"branchGnarliness2": 0.11,
		"branchGnarliness3": 0.09,
		"branchLength0": 28.08,
		"branchLength1": 4.55,
		"branchLength2": 9.78,
		"branchLength3": 7.16,
		"branchRadius0": 1,
		"branchRadius1": 1.02,
		"branchRadius2": 0.69,
		"branchRadius3": 1.19,
		"branchSections0": 16,
		"branchSections1": 9,
		"branchSections3": 1,
		"branchSegments0": 7,
		"branchSegments1": 5,
		"branchSegments2": 3,
		"branchStart1": 0.49,
		"branchStart2": 0.06,
		"branchStart3": 0.12,
		"branchTaper0": 0.73,
		"branchTaper1": 0.42,
		"branchTaper2": 0.69,
		"branchTaper3": 0.75,
		"branchTwist0": -0.23,
		"branchTwist1": 0.42,
		"leafCount": 14,
		"leafSize": 1.38,
		"leafAngle": 42,
		"leafStart": 0.16,
		"barkTint": 16774097,
		"barkTextureScaleY": 10,
		"targetHeight": 12.44,
	},
	footprintRadiusRatio: 0.39,
});
